import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink} from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { loadLocationWithMessage } from '../../../../actions/location'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PostAddIcon from '@material-ui/icons/PostAdd'
import '../../../../styles/assets/css/admin/list1.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Pagination from '../../../functions/pagination'
import { filter_patient_status } from '../variables/patient_1.js'
import Spinner from 'react-spinner-material'
import Graph1 from './graph1'

import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'

import CgiBDReport from "./cgi_bd_report"
import AssmReport from "./assessments_report"

class Reports extends Component {
  constructor() {
      super();
      this.state = {
        status: false,
        message: '',
        tab_status: '1',
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    this.setState({
      tab_status: this.props.match.params.main_tab,
    })
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tab_status: newValue,
    })
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  render() {
    return (
      <div className="patient_dashboard box_border4">
        <div className="row">
          <div className="small-12 medium-12 columns headerPage1">
            Reports
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns tab_data1 main_tab">
          <TabContext value={this.state.tab_status}>
            <AppBar position="static">
              <TabList onChange={this.handleTabChange} aria-label="simple tabs example">
                <Tab label="CGI-BD" value="1" />
                <Tab label="Assessments" value="2" />
                {/* */}
              </TabList>
            </AppBar>
            <TabPanel value="1" index={1} >
            {this.state.tab_status == 1 && <CgiBDReport />}
            </TabPanel>
            <TabPanel value="2" index={2} >
            {this.state.tab_status == 2 && <AssmReport />}
            </TabPanel>
          </TabContext>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Reports)
